module.exports = __webpack_public_path__ + "img/hr-heated-ending-left-1.14591431.png";